import { useGetUserQuery } from 'common'

import { useGetNotetakerFreeMeetingsQuotaQuery } from '../api'

/**
 * Hook to load notetaker free meetings quota and check for remaining usage.
 *
 * @param {{ skip?: boolean }} [options]
 * @returns {{ hasRemainingFreeMeetings: boolean, notetakerQuotaData: object | null | undefined }}
 */
export const useNotetakerFreeMeetingsQuota = (options = {}) => {
  const { skip = false } = options
  const { data: userData } = useGetUserQuery()
  const userUuid = userData?.uuid
  const shouldSkip = skip || !userUuid

  const { data: notetakerQuotaData } = useGetNotetakerFreeMeetingsQuotaQuery(
    { userUuid },
    { skip: shouldSkip }
  )

  return {
    hasRemainingFreeMeetings: notetakerQuotaData?.resource?.featureAvailable ?? false,
    notetakerQuotaData
  }
}
